import React, { FC, ReactNode } from 'react'

import T from 'components/FormattedMessage'
import { Box } from '@material-ui/core'

type Props = {
  color: string
  title: ReactNode
  points: number
}

const PoinstpreadGraphLegend: FC<Props> = ({ color, title, points }) => {
  return (
    <div>
      <Box
        width={{
          xs: 6,
          sm: 10,
        }}
        height={{
          xs: 6,
          sm: 10,
        }}
        mr={1}
        bgcolor={color}
        borderRadius={1}
        display="inline-block"
      />
      <Box
        color={color}
        display="inline"
        fontWeight="fontWeightMedium"
        fontSize={{
          xs: 10,
          sm: 14,
        }}
      >
        {title} ({points}<T id="common_unit_point" />)
      </Box>
    </div>
  )
}

export default PoinstpreadGraphLegend
try {
    // @ts-ignore
    PointspreadGraphLegend.displayName = "PointspreadGraphLegend";
    // @ts-ignore
    PointspreadGraphLegend.__docgenInfo = { "description": "", "displayName": "PointspreadGraphLegend", "props": { "color": { "defaultValue": null, "description": "", "name": "color", "required": true, "type": { "name": "string" } }, "title": { "defaultValue": null, "description": "", "name": "title", "required": true, "type": { "name": "ReactNode" } }, "points": { "defaultValue": null, "description": "", "name": "points", "required": true, "type": { "name": "number" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/PlayerLayer/components/PlayerProfile/tabs/PointspreadTab/components/PointspreadGraph/components/PointspreadGraphLegend.tsx#PointspreadGraphLegend"] = { docgenInfo: PointspreadGraphLegend.__docgenInfo, name: "PointspreadGraphLegend", path: "src/components/PlayerLayer/components/PlayerProfile/tabs/PointspreadTab/components/PointspreadGraph/components/PointspreadGraphLegend.tsx#PointspreadGraphLegend" };
}
catch (__react_docgen_typescript_loader_error) { }